import './style/index.js';

import _Menu from './Menu';

export type { HeadMenuProps } from './HeadMenu';
export type { MenuProps } from './Menu';
export type { MenuGroupProps } from './MenuGroup';
export type { MenuItemProps } from './MenuItem';
export type { SubMenuProps } from './SubMenu';
export * from './type';

export const Menu = _Menu;
export default Menu;
